import nexus from '@ospin/nexus'
import { updateUser } from '~/redux/actions/actions'

export default async (userData, userId, dispatch) => {
  if (!userData.cognitoIdentityIdSet) {
    await nexus.user.setCognitoIdentityId({ userId })
    dispatch(updateUser({ userData: { cognitoIdentityIdSet: true } }))
  }
}
